export default {
  /**
   * Takes an array of objects and returns an array containing all the objects that are unique via a specific key
   * @param arr an array of objects
   * @param key the key used to check for uniqueness
   * @returns {[]} an array containing the distinct objects
   */
  distinctObjects(arr, key) {
    let distinct = [],
      dict = {};
    for (let i = 0; i < arr.length; i++) {
      let obj = arr[i];
      if (!dict[obj[key]]) {
        dict[obj[key]] = true;
        distinct.push(obj);
      }
    }

    return distinct;
  },

  /**
   * Return an element's offset wrt document element
   * https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/docs/utils/index.js
   * @param {object} el the element to calculate position of
   * @returns {number} the vertical offset from the top of the screen in pixels
   */
  offsetTop(el) {
    if (!el.getClientRects().length) {
      return 0;
    }
    const bcr = el.getBoundingClientRect();
    const win = el.ownerDocument.defaultView;
    return bcr.top + win.pageYOffset;
  }
};
